import React from "react";

import BasicModal from "components/ui/BasicModal";

import QuoteDeliveryPanel from "./QuoteDeliveryPanel";

/**
 * WO_SEND_QUOTE.md + MOCKUP_FIDELITY_PASS.md D2 — the WO-level "Send
 * quote" action. MANUAL, WO-triggered, recipient-selected, never
 * automated.
 *
 * Session 65 item 3 (root cause C2): the branch UI (Email | CorrigoPro
 * toggle + both branches) now lives in `QuoteDeliveryPanel`, shared with
 * the embedded Quote tab so the two surfaces cannot drift. This modal is
 * a thin `BasicModal` shell around that panel — one implementation, two
 * mount points (RC2). The email recipient picker (Session 56) and the
 * mounted `CorrigoExportPanel` (RC5) both live in the shared panel now.
 *
 * WO progress is DERIVED (WO_STATUS_DERIVATION.md); this action never
 * hand-marks a "sent" state.
 *
 * Props:
 *   quoteId      — the quote to send (from wo.convertedRfq's newest quote)
 *   quote        — the LOADED quote object, required for the Corrigo branch
 *   intakeStyle  — plan intake style; picks the default branch
 *   clientId     — the WO's client, so the recipient picker can list the
 *                  client's contacts on file
 *   defaultEmail — prefill / site-contact recipient (WO FM / site contact)
 *   defaultCc    — prefill CC list (quote.contactsCC), operator edits
 *   initialBranch — force the opening branch (e.g. straight to Corrigo for
 *                  the WhatsNext "Accept on behalf" step)
 */
export default function SendQuoteModal({
  quoteId,
  quote,
  intakeStyle,
  clientId,
  defaultEmail,
  defaultCc,
  initialBranch,
  onClose,
  onSent,
}: {
  quoteId: string;
  quote?: any;
  intakeStyle?: "work_order_fed" | "quote_fed";
  clientId?: string | null;
  defaultEmail?: string | null;
  defaultCc?: string[] | null;
  initialBranch?: "email" | "corrigo";
  onClose: () => void;
  onSent?: () => void;
}) {
  return (
    <BasicModal title="Send quote" cancel_click={onClose} cancel_text="Close" size="md">
      <QuoteDeliveryPanel
        quoteId={quoteId}
        quote={quote}
        intakeStyle={intakeStyle}
        clientId={clientId}
        defaultEmail={defaultEmail}
        defaultCc={defaultCc}
        initialBranch={initialBranch}
        onSent={onSent}
        onClose={onClose}
      />
    </BasicModal>
  );
}
